// extracted by mini-css-extract-plugin
export default {"pieChart":"Loader_pieChart__ALaxW","circle-animation":"Loader_circle-animation__aX4M2"};